import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Plus, ShieldCheck } from "lucide-react";
import api from "../lib/api";
import { PageHeader, Spinner, Pill } from "../components/common";
import { useAuth } from "../context/AuthContext";

const STATUS_TONE = { published: "green", pending: "amber", rejected: "red", resolved: "green" };

export default function Dashboard() {
  const { user } = useAuth();
  const [items, setItems] = useState(null);

  useEffect(() => { api.get("/complaints/mine").then((r) => setItems(r.data)); }, []);

  return (
    <div data-testid="dashboard-page">
      <PageHeader plain eyebrow={`Signed in as ${user?.email}`} title="My Dashboard"
        subtitle="Track the complaints you've filed and their moderation status.">
        <div className="flex gap-3 mt-5">
          <Link to="/complaints/new" className="inline-flex items-center gap-2 bg-primary text-white px-5 py-2.5 text-sm font-semibold hover:bg-blue-700 transition-colors" data-testid="dashboard-new-complaint">
            <Plus className="w-4 h-4" /> File a complaint
          </Link>
          {["moderator", "admin"].includes(user?.role) && (
            <Link to="/moderation" className="inline-flex items-center gap-2 border border-primary text-primary px-5 py-2.5 text-sm font-semibold hover:bg-blue-50 transition-colors" data-testid="dashboard-moderation">
              <ShieldCheck className="w-4 h-4" /> Moderation queue
            </Link>
          )}
        </div>
      </PageHeader>

      <div className="max-w-7xl mx-auto px-5 lg:px-8 pb-16">
        {!items ? <Spinner /> : items.length === 0 ? (
          <div className="border border-dashed border-zinc-300 py-20 text-center">
            <p className="text-muted-foreground mb-4">You haven't filed any complaints yet.</p>
            <Link to="/complaints/new" className="text-primary hover:underline">File your first complaint →</Link>
          </div>
        ) : (
          <div className="space-y-3">
            {items.map((c) => (
              <Link key={c.complaint_id} to={`/complaints/${c.complaint_id}`} data-testid={`my-complaint-${c.complaint_id}`}
                className="flex items-center justify-between border border-zinc-300 bg-white p-5 hover:border-primary transition-colors">
                <div className="min-w-0">
                  <div className="flex items-center gap-2 mb-1">
                    <Pill tone={STATUS_TONE[c.status]}>{c.status}</Pill>
                    <Pill tone="red">{c.category}</Pill>
                    {c.official_response && <Pill tone="green">Official response</Pill>}
                  </div>
                  <div className="font-heading font-700 truncate">{c.title}</div>
                  <div className="text-xs font-mono text-muted-foreground mt-1">{c.entity_name} · ▲ {c.upvote_count} · {new Date(c.created_at).toLocaleDateString()}</div>
                </div>
              </Link>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
